module.exports = function (Restangular) {
    return Restangular.withConfig(RestangularConfigurer => RestangularConfigurer.setBaseUrl('/api/v3/ui'));
};



// WEBPACK FOOTER //
// ./src/configuration/restangular-v3.js